import request from '@/utils/request'
import VueCookies from 'vue-cookies'


// 获取用户的信息
export function getUserInfo() {
  return request({
    url: '/userInfo/getUserInfo',
    method: 'get'
  })
}


// 获取购物车的数量
export function getCartNum() {
  return request({
    url: '/shoppingCart/getNum',
    method: 'get'
  })
}


// 加入购物车
export function addShoppingCart(data) {
  return request({
    url: '/shoppingCart/addShoppingCart',
    method: 'post',
	data:data
  })
}


// 获取购物车列表
export function getShoppingCartList() {
  return request({
    url: '/shoppingCart/getShoppingCartList',
    method: 'get'
  })
}

// 调整购物车的数量
export function updateShoppingCartNum(data) {
  return request({
    url: '/shoppingCart/updateShoppingCartNum',
    method: 'post',
	data:data
  })
}


// 删除购物车
export function deleteShoppingCart(data) {
  return request({
    url: '/shoppingCart/deleteShoppingCart',
    method: 'post',
	data:data
  })
}


// 调整选中状态
export function updateShoppingCartSelected(data) {
  return request({
    url: '/shoppingCart/updateShoppingCartSelected',
    method: 'post',
	data:data
  })
}

//获取下单页面的订单详情
export function computePrice(data) {
  return request({
    url: '/order/computePrice',
    method: 'post',
	data:data
  })
}



//提交订单
export function createOrder(data) {
  return request({
    url: '/order/createOrder',
    method: 'post',
	data:data
  })
}


//截图提交
export function savePaymentImage(data) {
  return request({
    url: '/order/savePaymentImage',
    method: 'post',
	data:data
  })
}

//截图提交
export function saveTransferImage(data) {
  return request({
    url: '/order/saveTransferImage',
    method: 'post',
	data:data
  })
}


//获取订单详情
export function orderInfo(data) {
  return request({
    url: '/order/getDetail',
    method: 'get',
	params:data
  })
}




//立即支付
export function createPay(data) {
  return request({
    url: '/order/createPay',
    method: 'post',
	data:data
  })
}



//获取我的优惠券
export function userCouponList(data) {
  return request({
    url: '/userCoupon/getList',
    method: 'post',
	data:data
  })
}


//获取用户地址
export function getAddressList(data) {
  return request({
    url: '/userAddress/getAddressList',
    method: 'post',
	data:data
  })
}


//添加收货地址
export function saveAddress(data) {
  return request({
    url: '/userAddress/saveAddress',
    method: 'post',
	data:data
  })
}


//设置为默认地址
export function setDefaultStatus(data) {
  return request({
    url: '/userAddress/setDefaultStatus',
    method: 'post',
	data:data
  })
}


//删除地址
export function deleteAddress(data) {
  return request({
    url: '/userAddress/deleteAddress',
    method: 'post',
	data:data
  })
}



//获取地址详情
export function getAddressById(data) {
  return request({
    url: '/userAddress/getAddressById',
    method: 'get',
	params:data
  })
}



//获取可用的优惠券
export function getUserCouponList(data) {
  return request({
    url: '/userCoupon/getUserList',
    method: 'get',
	params:data
  })
}



//获取订单列表
export function getOrderList(data) {
  return request({
    url: '/order/getList',
    method: 'post',
	data:data
  })
}



//修改订单状态
export function updateOrderStatus(data) {
  return request({
    url: '/order/updateStatus',
    method: 'post',
	data:data
  })
}

//批量确认收货
export function batchConfirmReceive(data) {
  return request({
    url: '/order/batchConfirmReceive',
    method: 'post',
    data: data
  })
}


//修改下单地址
export function updateOrderAddress(data) {
  return request({
    url: '/order/updateAddress',
    method: 'post',
	data:data
  })
}



//再次购买
export function copyOrder(data) {
  return request({
    url: '/order/copyOrder',
    method: 'post',
	data:data
  })
}




//提交收货
export function createReturn(data) {
  return request({
    url: '/orderReturn/createReturn',
    method: 'post',
	data:data
  })
}



//修改旧密码
export function updatePassword(data) {
  return request({
    url: '/userInfo/updatePassword',
    method: 'post',
	data:data
  })
}



//获取旧手机号的验证码
export function sendCurrentPhoneCode(data) {
  return request({
    url: '/userInfo/sendCurrentPhoneCode',
    method: 'post',
	data:data
  })
}



//获取校验旧手机号的验证码是否正确
export function checkPhoneCode(data) {
  return request({
    url: '/userInfo/checkPhoneCode',
    method: 'post',
	data:data
  })
}



//修改手机号
export function updatePhone(data) {
  return request({
    url: '/userInfo/updatePhone',
    method: 'post',
	data:data
  })
}

//获取售后的原因
export function afterSalesReason() {
  return request({
    url: '/afterSalesReason/getList',
    method: 'get'
  })
}

//获取售后订单列表
export function orderReturnList(data) {
  return request({
    url: '/orderReturn/getList',
    method: 'post',
	data:data
  })
}

//获取售后订单详情
export function getReturnDetail(data) {
  return request({
    url: '/orderReturn/getReturnDetail',
    method: 'get',
	params:data
  })
}


//1批量支付：对订单进行打包，生成批量支付ID
export function createBatchPay(data) {
  return request({
    url: '/orderBatchPay/createBatchPay',
    method: 'post',
	data:data
  })
}


//2批量支付：获取批量支付详情
export function getBatchPay(data) {
  return request({
    url: '/orderBatchPay/getBatchPay',
    method: 'get',
	params:data
  })
}


///order/batchCreatePay
export function batchCreatePay(data) {
  return request({
    url: '/order/batchCreatePay',
    method: 'post',
	data:data
  })
}


///order/batchCreatePay
export function getExpireNum() {
  return request({
    url: '/order/getExpireNum',
    method: 'get'
  })
}


export function downloadExcel(data) {
  return request({
    url: '/order/downloadExcel',
    method: 'post',
	data:data,
	headers:{},
	responseType:"blob"
  })
}


//获取积分列表
export function userIntegralLog(data) {
  return request({
    url: '/userIntegralLog/getList',
    method: 'post',
	data:data
  })
}


//获取消息列表
export function sysMessageList(data) {
  return request({
    url: '/sysMessage/getList',
    method: 'post',
	data:data
  })
}

///order/batchCreatePay
export function sysMessageInfo(data) {
  return request({
    url: '/sysMessage/getDetail',
    method: 'get',
	params:data
  })
}
